import { render, staticRenderFns } from "./OtherSourceOfFunds.vue?vue&type=template&id=f47e6d2e&scoped=true&"
import script from "./OtherSourceOfFunds.vue?vue&type=script&lang=js&"
export * from "./OtherSourceOfFunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47e6d2e",
  null
  
)

export default component.exports